export default __webpack_public_path__ + "static/media/txt.231cd944.svg";